import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=03e092b9&scoped=true&"
import script from "./signup.vue?vue&type=script&lang=js&"
export * from "./signup.vue?vue&type=script&lang=js&"
import style0 from "./signup.vue?vue&type=style&index=0&id=03e092b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e092b9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AuthButton: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/global/AuthButton.vue').default,MobilePhoneSelector: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/global/mobilePhoneSelector.vue').default,CountrySelector: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/global/countrySelector.vue').default,I18n: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/i18n.vue').default,Modal: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/global/modal.vue').default})
